// removed by extract-text-webpack-plugin
module.exports = {"container":"CustomFooter__container___2jzEf","cventLinks":"CustomFooter__cventLinks___2wbWL","policyLinks":"CustomFooter__policyLinks___1H8JA","list":"CustomFooter__list___nNIEk","link":"CustomFooter__link___2nSUw"};


//////////////////
// WEBPACK FOOTER
// ./~/nucleus-widgets/lib/Footer/CustomFooter.less
// module id = ./node_modules/nucleus-widgets/lib/Footer/CustomFooter.less
// module chunks = 55